export default "__VITE_ASSET__DfygkH6Q__"